export const gitnum = {
      version: 'v1.0.198',
      git: '198',
      branch: 'react18-vite',
      commit: '3d6470d',
      describe: 'v1.0',
      date:'18/08/2026 14:34'
    };
    